/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useEffect, useState } from 'react';

import { Loader, Notification } from '@scuf/common';

import { Modal } from '@scuf/common';

import i18next from 'i18next';

import './EnergyStarWidget.scss';

import { useTranslation } from '@scuf/localization';

import descriptors from '../../locales/en-US/descriptors';

import { ApiContext } from '../../context/ApiContext';

import useConnectorAndDynamicProps from '../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';

import { IRequestContext } from './EnergyStarProps';

// import './EnergyStarErrorModel.scss';

interface IEnergyStarErrorModel {
  onClose: () => void;

  requestContext: IRequestContext;
}

const RESPONSE_OK = 204;

export const EnergyStarErrorModel = (props: IEnergyStarErrorModel) => {
  const { requestContext } = props;

  const [htmlResponse, setHtmlResponse] = useState<any>([]);

  const [t] = useTranslation();

  const d = descriptors.energyStar;

  const connectorConfig = {
    name: 'energy-star-get-reason-for-noscore'
  };

  const apiContext = useContext(ApiContext);

  const { notifyMessage } = apiContext;

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,

    requestContext
  });

  const { all, loading, error, status } = dataConnector.data;

  let isDataAvailable = false;

  if (all) {
    isDataAvailable = true;
  }

  const checkDataAvail = () => {
    return isDataAvailable || error || status;
  };
  useEffect(() => {
    if (checkDataAvail() && !loading) {
      if (isDataAvailable) {
        setHtmlResponse(all);
      }
      if (status && status > RESPONSE_OK) {
        notifyMessage && notifyMessage(t(d.notifyServerError), 'error');
        props.onClose();
      } else if (status && status === RESPONSE_OK) {
        notifyMessage &&
          notifyMessage(t(d.EnergyStarNoScoreNoContentMessage), 'warn');
        props.onClose();
      } else {
        //Do Nothing
      }
    }
  }, [isDataAvailable, loading, status]);

  return (
    <Modal
      open={true}
      onClose={() => props.onClose()}
      size="large"
      className="energy-star-error-box"
      closeIcon={true}
    >
      {/* <Modal.Header></Modal.Header> */}

      <Modal.Content>
        <div className="errorHeading">{t(d.SomethingWentWrong)}</div>

        <Notification
          className="energy-star-notification"
          hasIcon={true}
          title="Error !"
        >
          {loading ? (
            <Loader text={t(d.loading)} />
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: `${
                  htmlResponse && htmlResponse.length > 0
                    ? htmlResponse.map(
                        (res: { description: any }) => res.description
                      )
                    : ''
                }`
              }}
            ></div>
          )}
        </Notification>
      </Modal.Content>
    </Modal>
  );
};
